import React, { useEffect } from 'react'
import { NavLink, Link } from 'react-router-dom'
import AOS from "aos";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "aos/dist/aos.css";
function Nav({ children }) {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="drawer drawer-end bg" data-theme="light">
      <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
      <div className="drawer-content  flex flex-col">
        <div className="w-full effect-nav navBar lg:px-[140px] px-[20px]  navbar shadow-md bg-[#080818e8] text-white">
          <Link to='/' className="nav-logo flex-1 px-2 logo mx-2 text-[30px] text-secondary">Hr Meheraj</Link>
          <div className="flex-none hidden lg:block">
            <ul className="menu menu-horizontal">
              <li><NavLink to="/contact">Contact</NavLink></li>
          <li><NavLink  to="/blogs">Blogs</NavLink></li>
              <li><NavLink to="/resume">Resume</NavLink></li>
            </ul>
          </div>

          <div className="flex-none lg:hidden">
            <label for="my-drawer-3" className="hover:bg-[#000019a1] transition-all btn btn-square btn-ghost">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
              </svg>
            </label>
          </div>

        </div>

        <div className='mt-[15px] max-w-[1080px] mx-auto w-[95%]'>
          {children}
        </div>
      </div>
      <div className="drawer-side">
        <label for="my-drawer-3" className="drawer-overlay"></label>
        <ul className="menu p-4 gap-y-[15px] overflow-y-auto effect w-[250px] bg-base-100">
          <li><NavLink className={'hover:bg-[#10102659]'} to="/">Home</NavLink></li>
          <li><NavLink className={'hover:bg-[#10102659]'} to="/contact">Contact</NavLink></li>
          <li><NavLink className={'hover:bg-[#10102659]'} to="/resume">Resume</NavLink></li>
          <li><NavLink className={'hover:bg-[#10102659]'} to="/blogs">Blogs</NavLink></li>

        </ul>

      </div>
      <ToastContainer />
    </div>
  )
}

export default Nav